import React, { FC, useEffect, useRef } from 'react';
import { batch, useSelector, useDispatch } from 'react-redux';
import { OrderTypeZeroSelectComponent } from '@component/index';
import { OnSelectProductHandler } from '@app/react/uikit';
import { hideEcHeaderNavi } from '@app/react/common/Function';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import type { PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { IinitState } from '@app/react/reducer/PartsSelectReducer';
import {
    partsSelectActions,
    apiGetActions,
    typezeroPageOpenDetectionAction,
} from '@app/react/action';
import { noProduct } from '@root/app/react/const/products/noProduct';
import { useWindowScrollPosition } from '@app/react/hooks/useWindowScrollPosition';
import useMedia from 'use-media';
import { useMediaDesktop, useMediaMobile } from '../common/useMedia';

export const OrderTypeZeroSelectContainer: FC<{ waitFetch?: boolean }> = ({ waitFetch = false }) => {
    const dispatch = useDispatch();
    const { arrowType, orderType } = useOrderPathParams();

    const scrollObj = useRef(null);
    useWindowScrollPosition('scroll_typezero', true, scrollObj);

    const customizeData = useSelector<AppState, IinitState>(
        (state) => state.customize,
    );
    const product = useSelector<AppState, PartsProduct | null>(
        (state) => state.customize.typezero,
    );
    const partsData = useSelector<AppState, Array<PartsProduct>>(
        (state) => state.APIData.typezero?.partsData || [],
    );

    const handleClick: OnSelectProductHandler = (__, p) => {
        dispatch(partsSelectActions.typezero.started({ param: p }));
    };

    const isDesktop: boolean = useMediaDesktop(useMedia);
    const isMobile: boolean = useMediaMobile(useMedia);

    useEffect(() => {
        hideEcHeaderNavi(isDesktop, isMobile, dispatch);
    }, [isDesktop, isMobile, dispatch]);

    useEffect(() => {
        if (waitFetch) {
            console.log('initializing, waiting fetch');
            return;
        }
        batch(() => {
            dispatch(
                apiGetActions.typezero.started({
                    arrowType,
                    orderType,
                    selectItems: customizeData,
                }),
            );
            dispatch(typezeroPageOpenDetectionAction({ open: true }));
        });

        return () => {
            dispatch(typezeroPageOpenDetectionAction({ open: false }));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, arrowType, orderType, waitFetch]);

    return (
        <OrderTypeZeroSelectComponent
            rootRef={scrollObj}
            noProduct={noProduct}
            yesProduct={partsData[0]}
            selectedProduct={product}
            onSelectProduct={handleClick}
        />
    );
};
